import React, { forwardRef } from "react";
import Slider from "react-slick";

export default function AutoPlay({ settings, children }) {
  return <Slider {...settings}>{children}</Slider>;
}

export function SolidPlay({ futurejobs, children }) {
  return <Slider {...futurejobs}>{children}</Slider>;
}

// export function VerticalMode({ vsettings, children }) {
//   return <Slider {...vsettings}>{children}</Slider>;
// }


export const VerticalMode = forwardRef(({ vsettings, children }, ref) => {
  return (
    <Slider ref={ref} {...vsettings}>
      {children}
    </Slider>
  );
});

// Good practice: Name it for React DevTools since forwardRef hides the function name
VerticalMode.displayName = "VerticalMode";